/* ベルばら特設LP(lp-rose-*)用スクリプト
 * - lp-rose-menu:   バラ型ハンバーガー + 全画面アンカーメニュー
 * - lp-rose-ring:   商品カードの3D回転リング(自動回転 + ドラッグ操作)
 * - lp-rose-petals: 花びらが舞う演出
 */

class LpRoseMenu extends HTMLElement {
  connectedCallback() {
    this.toggleButton = this.querySelector('.lp-rose-menu__toggle');
    this.overlay = this.querySelector('.lp-rose-menu__overlay');
    if (!this.toggleButton || !this.overlay) return;

    this.toggleButton.addEventListener('click', () => {
      this.classList.contains('is-open') ? this.close() : this.open();
    });
    this.overlay.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => this.close());
    });
    this.onKeydown = (event) => {
      if (event.key === 'Escape') this.close();
    };
    document.addEventListener('keydown', this.onKeydown);
  }

  disconnectedCallback() {
    document.removeEventListener('keydown', this.onKeydown);
  }

  open() {
    this.classList.add('is-open');
    this.toggleButton.setAttribute('aria-expanded', 'true');
    document.body.classList.add('lp-rose-menu-open');
  }

  close() {
    this.classList.remove('is-open');
    this.toggleButton.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('lp-rose-menu-open');
  }
}
customElements.define('lp-rose-menu', LpRoseMenu);

class LpRoseRing extends HTMLElement {
  connectedCallback() {
    this.ring = this.querySelector('.lp-rose-ring__ring');
    this.cards = Array.from(this.querySelectorAll('.lp-rose-ring__card'));
    if (!this.ring || this.cards.length === 0) return;

    this.depth = 232;
    this.rotation = 0;
    this.dragging = false;
    this.lastX = 0;
    this.autoRotate = this.dataset.autoRotate === 'true';
    // data-rotate-speed は deg/秒。60fps 前提で1フレームあたりに換算
    this.frameSpeed = (parseFloat(this.dataset.rotateSpeed) || 0) / 60;
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    this.addEventListener('pointerdown', (event) => {
      this.dragging = true;
      this.lastX = event.clientX;
      this.dragTotal = 0;
    });
    // ドラッグ操作の直後はカードのアンカーリンクへ遷移させない
    this.addEventListener(
      'click',
      (event) => {
        if ((this.dragTotal || 0) > 6) {
          event.preventDefault();
          event.stopPropagation();
        }
      },
      true
    );
    this.onPointerMove = (event) => {
      if (!this.dragging) return;
      const delta = event.clientX - this.lastX;
      this.dragTotal = (this.dragTotal || 0) + Math.abs(delta);
      this.rotation += delta * 0.35;
      this.lastX = event.clientX;
      if (this.reducedMotion) this.render();
    };
    this.onPointerUp = () => {
      this.dragging = false;
    };
    window.addEventListener('pointermove', this.onPointerMove);
    window.addEventListener('pointerup', this.onPointerUp);

    this.render();
    if (!this.reducedMotion) {
      this.loop = this.loop.bind(this);
      this.raf = requestAnimationFrame(this.loop);
    }
  }

  disconnectedCallback() {
    cancelAnimationFrame(this.raf);
    window.removeEventListener('pointermove', this.onPointerMove);
    window.removeEventListener('pointerup', this.onPointerUp);
  }

  loop() {
    if (!this.dragging && this.autoRotate) this.rotation += this.frameSpeed;
    this.render();
    this.raf = requestAnimationFrame(this.loop);
  }

  render() {
    const count = this.cards.length;
    this.ring.style.transform =
      'translateZ(-' + this.depth + 'px) rotateX(-12deg) rotateY(' + this.rotation + 'deg)';
    for (let i = 0; i < count; i++) {
      const angle = (i * 360) / count;
      // 正面(facing=1)〜背面(facing=0)で拡縮・上下位置・透明度を変える
      const facing = (Math.cos(((this.rotation + angle) * Math.PI) / 180) + 1) / 2;
      const card = this.cards[i];
      card.style.transform =
        'rotateY(' + angle + 'deg) translateZ(' + this.depth + 'px) translateY(' +
        (30 - (1 - facing) * 90).toFixed(1) + 'px) scale(' + (0.68 + 0.52 * facing).toFixed(3) + ')';
      card.style.opacity = (0.45 + 0.55 * facing).toFixed(3);
    }
  }
}
customElements.define('lp-rose-ring', LpRoseRing);

class LpRosePetals extends HTMLElement {
  connectedCallback() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const count = parseInt(this.dataset.count, 10) || 0;
    for (let i = 0; i < count; i++) {
      const size = 9 + Math.random() * 9;
      const duration = 9 + Math.random() * 9;
      const petal = document.createElement('div');
      petal.className = 'lp-rose-petal';
      // 主要スタイルはインラインで確実に適用する
      // display はテーマの div:empty { display:none } (base.css) に消されないよう必須
      petal.style.display = 'block';
      petal.style.position = 'absolute';
      petal.style.top = '-6vh';
      petal.style.left = Math.random() * 96 + '%';
      petal.style.width = size + 'px';
      petal.style.height = size * 1.25 + 'px';
      petal.style.background = 'radial-gradient(circle at 35% 30%, #c14a5e, #8f1f33 70%)';
      petal.style.borderRadius = '78% 4% 62% 48% / 58% 6% 80% 42%';
      petal.style.opacity = (0.28 + Math.random() * 0.4).toFixed(2);
      // 負のdelayで、読み込み直後から花びらが落下経路上に分布した状態にする
      petal.style.animation =
        'lpRosePetalFall ' + duration.toFixed(1) + 's linear -' +
        (Math.random() * duration).toFixed(1) + 's infinite';
      this.appendChild(petal);
    }
  }
}
customElements.define('lp-rose-petals', LpRosePetals);
